export default "assets/images/icons/instagram-ea616f22.svg";